import "core-js/modules/es.object.define-property";
import { __decorate, __extends } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
var Common = namespace('common');

var ProtocolLog = function (_super) {
  __extends(ProtocolLog, _super);

  function ProtocolLog() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Object.defineProperty(ProtocolLog.prototype, "gdUrl", {
    get: function get() {
      return window.location.origin;
    },
    enumerable: false,
    configurable: true
  });

  ProtocolLog.prototype.handleBack = function () {
    this.$router.push({
      name: 'CustomerInactivePage'
    });
  };

  ProtocolLog.prototype.handleNext = function () {
    this.$emit('next', this.$enum.mine.LogoutStepEnum.ConfirmLogout);
  };

  ProtocolLog.prototype.created = function () {};

  __decorate([Common.Getter('commonBizList')], ProtocolLog.prototype, "commonBizList", void 0);

  ProtocolLog = __decorate([Component], ProtocolLog);
  return ProtocolLog;
}(Vue);

export default ProtocolLog;